import React, {
  Fragment,
  useEffect,
  useState,
  useMemo,
  useCallback,
  useRef,
} from "react";
import {
  Table,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  CardHeader,
  Nav,
  NavItem,
  NavLink,
  Row,
  Modal,
  ModalHeader,
  Form,
  ModalBody,
  Label,
  Input,
  FormFeedback,
  Spinner,
} from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../../Components/Common/DeleteModal";
import ApproveModal from "../../../../Components/Common/ApproveModal";
import { isEmpty, clone } from "lodash";
import {
  useTable,
  useGlobalFilter,
  useAsyncDebounce,
  useSortBy,
  useFilters,
  useExpanded,
  usePagination,
  useRowSelect,
} from "react-table";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import {
  resetSurveyScoreState,
  getSurveyScore,
} from "../../../../store/surveyScore/action";
import { resetCompanyState, getCompany } from "../../../../store/company/action";
import { resetClientState, getClient } from "../../../../store/client/action";
import {
  resetSurveyTemplateDetailState,
  getSurveyTemplateDetail as onGetSurveyTemplateDetails,
  addNewSurveyTemplateDetail as onAddNewSurveyTemplateDetail,
  updateSurveyTemplateDetail as onUpdateSurveyTemplateDetail,
  deleteSurveyTemplateDetail as onDeleteSurveyTemplateDetail,
  getSurveyTemplateDetailLoading,
} from "../../../../store/surveyTemplateDetail/action";
import {
  getSurveyTemplate as onGetSurveyTemplates,
  addNewSurveyTemplate as onAddNewSurveyTemplate,
  updateSurveyTemplate as onUpdateSurveyTemplate,
  deleteSurveyTemplate as onDeleteSurveyTemplate,
  getSurveyTemplateLoading,
  resetSurveyTemplateState,
} from "../../../../store/surveyTemplate/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const SurveyTemplate = () => {
  const [modal, setModal] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [companyName, setCompanyName] = useState({});
  const [clientName, setClientName] = useState({});
  const dispatch = useDispatch();

  const {
    surveyTemplates,
    isSurveyTemplateCreated,
    isSurveyTemplateSuccess,
    loading,
    error,
    surveyTemplateDetails,
    surveyTemplateDetailLoading,
    isSurveyTemplateDetailCreated,
    isSurveyTemplateDetailSuccess,
    companies,
    companyLoading,
    surveyScores,
    surveyScoreLoading,
    positions,
    positionLoading,
    clients,
    clientLoading,
  } = useSelector((state) => ({
    surveyTemplates: state.SurveyTemplate.surveyTemplates,
    isSurveyTemplateCreated:
      state.SurveyTemplate.isSurveyTemplateCreated,
    isSurveyTemplateSuccess:
      state.SurveyTemplate.isSurveyTemplateSuccess,
    loading: state.SurveyTemplate.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    error: state.SurveyTemplate.error,
    surveyTemplateDetails:
      state.SurveyTemplateDetail.surveyTemplateDetails,
    surveyTemplateDetailLoading: state.SurveyTemplateDetail.loading,
    isSurveyTemplateDetailCreated:
      state.SurveyTemplateDetail.isSurveyTemplateDetailCreated,
    isSurveyTemplateDetailSuccess:
      state.SurveyTemplateDetail.isSurveyTemplateDetailSuccess,
    surveyScores: state.SurveyScore.surveyScores,
    surveyScoreLoading: state.SurveyScore.loading,
    positions: state.Position.positions,
    positionLoading: state.Position.loading,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
  }));

  const [isSearch, setIsSearch] = useState(false);
  const [surveyTemplateList, setSurveyTemplateList] = useState([]);
  const [surveyTemplate, setSurveyTemplate] = useState([]);
  const [appraisalDetailAddedId, setTemplateDetailAddedId] = useState(0);
  const [info, setInfo] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [surveyTemplateDetail, setSurveyTemplateDetail] = useState(
    []
  );
  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [surveyScoreList, setSurveyScoreList] = useState([]);
  const [approveModal, setApproveModal] = useState(false);
  const [positionList, setPositionList] = useState([]);
  const [userRole, setRoles] = useState(null);
  const [userType, setUserType] = useState("user");

  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isEditDetail, setIsEditDetail] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalDetail, setDeleteModalDetail] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [detailList, setDetailList] = useState([])
  const [searchValueSecond, setSearchValueSecond] = useState([]);
  const ref = useRef(null);

  const defaultdate = () => {
    return moment(new Date())

      .format("YYYY/MM/DD HH:mm:ss")
      .toString();
  };

  const onClickDelete = (surveyTemplate) => {
    setSurveyTemplate(surveyTemplate);
    setDeleteModal(true);
  };

  const onClickDeleteDetail = (surveyTemplateDetail) => {
    setSurveyTemplateDetail(surveyTemplateDetail);
    setDeleteModalDetail(true);
  };

  const handleDeleteSurveyTemplate = () => {
    if (surveyTemplate) {
      dispatch(onDeleteSurveyTemplate(surveyTemplate));
      setDeleteModal(false);
    }
  };

  const handleDeleteSurveyTemplateDetail = () => {
    if (surveyTemplateDetail) {
      setTemplateDetailAddedId(surveyTemplateDetail.templateId);
      dispatch(onDeleteSurveyTemplateDetail(surveyTemplateDetail));
      setDeleteModalDetail(false);
    }
  };

  const onClickApprove = (employee) => {
    setSurveyTemplate(employee);
    setApproveModal(true);
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      let filteredSurveyTemplates = surveyTemplates;
      if (type !== "all") {
        filteredSurveyTemplates = surveyTemplates.filter(
          (surveyTemplate) =>
            surveyTemplate.svt_status.name === type
        );
      }
      setSurveyTemplateList(filteredSurveyTemplates);
    }
  };

  useEffect(() => {
    if (!isSearch) {
      dispatch(onGetSurveyTemplates());
      dispatch(resetClientState());
      dispatch(getClient());
      setIsSearch(true);
      const obj = JSON.parse(localStorage.getItem("authUser"));
      if (
        obj.data &&
        obj?.data?.user?.user_position &&
        obj?.data?.user?.user_position?.position_role
      ) {
        setCompanyName({
          label: obj?.data?.user.user_company.name,
          value: obj?.data?.user.user_company.id,
        });
        setClientName({
          label: obj?.data?.user.user_client.name,
          value: obj?.data?.user.user_client.id,
        });
        setRoles(obj?.data?.user?.user_position?.position_role);
      } else setRoles(null);

      if (obj?.data) setUserType(obj?.data?.userType);
    }
  }, [dispatch, surveyTemplates, isSearch]);

  useEffect(() => {
    if (!isEmpty(surveyTemplates)) {
      setIsEdit(false);
      setSurveyTemplateList(surveyTemplates);
      let current = 0;
      if (appraisalDetailAddedId !== 0) {
        surveyTemplates.forEach((obj, i) => {
          if (obj.id === appraisalDetailAddedId) current = i;
        });
      }
      setInfo(surveyTemplates[current]);
    }
  }, [surveyTemplates, appraisalDetailAddedId]);

  useEffect(() => {
    if (isSurveyTemplateDetailCreated) {
      dispatch(resetSurveyTemplateDetailState());
      dispatch(resetSurveyTemplateState());
      dispatch(onGetSurveyTemplates());
    }
  }, [dispatch, isSurveyTemplateDetailCreated]);

  // useEffect(() => {
  //   if (companies && !companies.length) {
  //     dispatch(resetCompanyState());
  //     dispatch(getCompany());
  //   }
  // }, [dispatch, companies]);

  // useEffect(() => {
  //   if (userType !== "admin") {
  //     if (companyName) {
  //       dispatch(getPosition({ companyId: companyName.value, status: 2 }));
  //     }
  //   }
  // }, [companyName, userType, dispatch]);

  function handleCompany(e) {
    if (e.length > 2) {
      const param = { title: e, status: 2 };
      dispatch(getCompany(param));
    }
    return false;
  }

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(positions)) {
      var data = [];
      var opt = [];
      positions.forEach((item, key) => {
        const position_name = item.name;
        const departmentId = item.departmentId;
        const name = item.position_department && item.position_department.name;
        const id = item.id;
        var obj = {
          label: position_name + ", " + name,
          value: id,
          positionId: id,
          position_name: position_name,
          departmentId: departmentId,
          name: name,
        };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setPositionList(data);
    }
  }, [positions]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (!isEmpty(surveyScores)) {
      var data = [];
      var opt = [];
      surveyScores.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setSurveyScoreList(data);
    }
  }, [surveyScores]);

  const [filterDate, setFilterDate] = useState(null);

  const handleValidDate = (date) => {
    return moment(new Date(date), "YYYY/MM/DD")

      .format("MMM D, YYYY");
  };

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setSurveyTemplate(null);
    } else {
      setModal(true);
    }
  }, [modal]);

  const handleGetCompany = (id) => {
    dispatch(resetCompanyState());
    dispatch(getCompany({ clientId: id }));
  };

  const handleSurveyTemplateClick = useCallback(
    (arg) => {
      const data = arg;
      setSurveyTemplate({
        id: data.id,
        percentage: data.percentage,
        description: data.description,
        company: {
          label: data.svt_company.name,
          value: data.svt_company.id,
        },
        client: {
          label: data.svt_client.name,
          value: data.svt_client.id,
        },
      });

      setIsEdit(true);
      toggle();
    },
    [toggle]
  );

  const toggleDetail = useCallback(() => {
    if (modalDetail) {
      setModalDetail(false);
      setSurveyTemplateDetail(null);
      setSurveyTemplate(null);
      setSurveyScoreList([]);
    } else {
      setModalDetail(true);
    }
  }, [modalDetail]);

  const handleSurveyTemplateDetailClick = useCallback(
    (arg) => {
      const data = arg;

      setSurveyTemplateDetail({
        id: data.id,
        templateId: data.templateId,
        description: data.description,
        score: data.score,
      });

      setIsEditDetail(true);
      toggleDetail();
    },
    [toggleDetail]
  );

  const columns = useMemo(
    () => [
      {
        Header: " ",
        maxWidth: 100,
        filterable: false,
        Cell: (cellProps) => {
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              {cellProps.row.original.statusId === 1 ? (
                <button
                  className="btn-label btn btn-sm btn-soft-success fs-12 me-0"
                  onClick={() => {
                    let data = cellProps.row.original;
                    onClickApprove(data);
                  }}><i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i>
                  Approve
                </button>
              ) : (
                ""
              )}
              <Link
                to="#"
                className="btn-icon btn btn-sm btn-light"
                onClick={() => {
                  setInfo(cellProps.row.original);
                  ref.current?.scrollIntoView({ behavior: "smooth" });
                }}>
                <i className="ri-eye-line fs-15"></i>
              </Link>
              <Link
                to="#"
                className={
                  userType === "admin"
                    ? "btn-icon btn btn-sm btn-light edit-item-btn"
                    : userRole &&
                      userRole.split(",").indexOf("updateSurveyTemplate") !==
                      -1
                      ? "btn-icon btn btn-sm btn-light edit-item-btn"
                      : "btn-icon btn btn-sm btn-light edit-item-btn d-none"
                }
                onClick={() => {
                  handleSurveyTemplateClick(cellProps.row.original);
                }}>
                <i className="ri-edit-2-line fs-15"></i>
              </Link>
              <Link
                to="#"
                className={
                  userType === "admin"
                    ? "btn-icon btn btn-sm btn-soft-danger remove-item-btn"
                    : userRole &&
                      userRole.split(",").indexOf("deleteSurveyTemplate") !==
                      -1
                      ? "btn-icon btn btn-sm btn-soft-danger remove-item-btn"
                      : "btn-icon btn btn-sm btn-soft-danger remove-item-btn d-none"
                }
                onClick={() => {
                  const surveyTemplateData = cellProps.row.original;
                  onClickDelete(surveyTemplateData);
                }}>
                <i className="ri-delete-bin-line fs-15 text-danger"></i>
              </Link>
            </div>
          );
        },
      },
      {
        Header: "Keterangan",
        accessor: "description",
        filterable: true,
      },
      {
        Header: "% Value",
        accessor: "percentage",
        filterable: true,
      },
      {
        Header: "Status",
        accessor: "svt_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "DRAFT":
              return (
                <span className="badge text-uppercase badge-soft-warning">
                  {cell.value}
                </span>
              );
            case "ACTIVE":
              return (
                <span className="badge text-uppercase badge-soft-info">
                  {cell.value}
                </span>
              );
            case "INACTIVE":
              return (
                <span className="badge text-uppercase badge-soft-danger">
                  {cell.value}
                </span>
              );
            default:
              return (
                <span className="badge text-uppercase badge-soft-warning">
                  {cell.value}
                </span>
              );
          }
        },
      },
    ],
    [handleSurveyTemplateClick, userType, userRole]
  );

  const {
    getTableProps, rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: surveyTemplateList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 8,
        selectedRowIds: 0,

      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const columnsSecond = useMemo(
    () => [
      {
        Header: " ",
        maxWidth: 100,
        filterable: false,
        Cell: (cellProps) => {
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <Link
                to="#"
                className={"btn-icon btn btn-sm btn-light edit-item-btn"}
                onClick={() => {
                  handleSurveyTemplateDetailClick(cellProps.row.original);
                }}><i className="ri-edit-2-line fs-15"></i>
              </Link>
              <Link
                to="#"
                className="btn-icon btn btn-sm btn-soft-danger remove-item-btn"
                onClick={() => {
                  const productOptionData = cellProps.row.original;
                  onClickDeleteDetail(productOptionData);
                }}><i className="ri-delete-bin-line fs-15 text-danger"></i>
              </Link>
            </div>
          );
        },
      },
      {
        Header: "Score",
        accessor: "score",
        filterable: true,
      },
      {
        Header: "Keterangan",
        accessor: "description",
        filterable: true,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [info]
  );

  const {
    getTableProps: getTablePropsSecond,
    getTableBodyProps: getTableBodyPropsSecond,
    headerGroups: headerGroupsSecond,
    page: pageSecond,
    prepareRow: prepareRowSecond,
    canPreviousPage: canPreviousPageSecond,
    canNextPage: canNextPageSecond,
    pageOptions: pageOptionsSecond,
    gotoPage: gotoPageSecond,
    nextPage: nextPageSecond,
    previousPage: previousPageSecond,
    setPageSize: setPageSizeSecond,
    preGlobalFilteredRows: preGlobalFilteredRowsSecond,
    setGlobalFilter: setGlobalFilterSecond,
    state: { pageIndex: pageIndexSecond, pageSize: pageSizeSecond },
  } = useTable(
    {
      columns: columnsSecond,
      data: detailList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 8,
        selectedRowIds: 0,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const onChangeInSelectSecond = (event) => {
    setPageSizeSecond(Number(event.target.value));
  };

  const onChangeInInputSecond = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPageSecond(page);
  };

  const onChangeSecond = useAsyncDebounce((value) => {
    setGlobalFilterSecond(value || undefined);
  }, 200);


  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable
      ? column.isSorted
        ? column.isSortedDesc
          ? " sorting_desc"
          : " sorting_asc"
        : " sort"
      : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 200);

  const handleApproveTemplate = () => {
    if (surveyTemplate) {
      surveyTemplate.setApprove = true;
      dispatch(onUpdateSurveyTemplate(surveyTemplate));
      setApproveModal(false);
    }
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      description: surveyTemplate && surveyTemplate.description,
      company:
        userType !== "admin"
          ? companyName
          : surveyTemplate && surveyTemplate.company,
      percentage:
        (surveyTemplate && surveyTemplate.percentage) || 0,
      client:
        userType !== "admin"
          ? clientName
          : surveyTemplate && surveyTemplate.client,
    },
    validationSchema: Yup.object({
      company: Yup.object().required("Please Enter Company").nullable(true),
      percentage: Yup.string()
        .required("Please Enter Percentage Value")
        .nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getSurveyTemplateLoading());
      if (isEdit) {
        const updateSurveyTemplate = {
          id: surveyTemplate ? surveyTemplate.id : 0,
          description: values.description,
          percentage: values.percentage,
          companyId: values.company.value,
          statusId: 1,
          clientId: values.client.value,
        };
        dispatch(onUpdateSurveyTemplate(updateSurveyTemplate));
        validation.resetForm();
      } else {
        const newSurveyTemplate = {
          description: values.description,
          percentage: values.percentage,
          companyId: values.company.value,
          statusId: 1,
          clientId: values.client.value,
        };
        dispatch(onAddNewSurveyTemplate(newSurveyTemplate));
        validation.resetForm();
      }
      toggle();
    },
  });

  const validationDetail = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      templateId:
        (surveyTemplateDetail &&
          surveyTemplateDetail.templateId) ||
        (surveyTemplate && surveyTemplate.id),
      score: surveyTemplateDetail && surveyTemplateDetail.score,
      description:
        (surveyTemplateDetail &&
          surveyTemplateDetail.description) ||
        "",
    },
    validationSchema: Yup.object({
      score: Yup.number().required("Please Enter Score Value").nullable(true),
    }),
    onSubmit: (values) => {
      setTemplateDetailAddedId(values.templateId);
      dispatch(getSurveyTemplateLoading());
      if (isEditDetail) {
        const updateSurveyTemplateDetail = {
          id: surveyTemplateDetail ? surveyTemplateDetail.id : 0,
          score: values.score,
          description: values.description,
          templateId: values.templateId,
          statusId: 2,
        };
        dispatch(
          onUpdateSurveyTemplateDetail(updateSurveyTemplateDetail)
        );
        validationDetail.resetForm();
      } else {
        const newSurveyTemplateDetail = {
          score: values.score,
          description: values.description,
          templateId: values.templateId,
          statusId: 2,
        };
        dispatch(
          onAddNewSurveyTemplateDetail(newSurveyTemplateDetail)
        );
        validationDetail.resetForm();
      }
      toggleDetail();
    },
  });

  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".dataCheckbox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteSurveyTemplateDetail(element.value));
    });
    checkall.checked = false;
  };

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr[1]) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
    };
    dispatch(onGetSurveyTemplates(param));
  }

  useEffect(() => {
    if (info && info.svt_detail) {
      setDetailList(info.svt_detail)
    }
  }, [info])

  document.title = "Survey Template | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ApproveModal
        data={
          surveyTemplate && surveyTemplate.contract_employee
            ? surveyTemplate.contract_employee.name
            : ""
        }
        show={approveModal}
        onApproveClick={handleApproveTemplate}
        onCloseClick={() => setApproveModal(false)} />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteSurveyTemplate}
        onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal
        show={deleteModalDetail}
        onDeleteClick={handleDeleteSurveyTemplateDetail}
        onCloseClick={() => setDeleteModalDetail(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)} />
      <Container fluid>
        <BreadCrumb title="Survey Template" pageTitle="Sales" />
        <Row>
          <Col xxl={12}>
            <Card>
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">
                    Survey Template Category Data &nbsp;
                    {isLoading ? (
                      <>
                        <Spinner color="primary" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                        <Spinner color="success" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                      </>
                    ) : (
                      ""
                    )}
                  </h5>
                  <div className="flex-shrink-0">
                    <button
                      type="button"
                      className={
                        userType === "admin"
                          ? "btn btn-primary add-btn me-2"
                          : userRole &&
                            userRole
                              .split(",")
                              .indexOf("createSurveyTemplate") !== -1
                            ? "btn btn-primary add-btn me-2"
                            : "btn btn-primary add-btn me-2 d-none"
                      }
                      id="create-btn" onClick={() => {
                        setSurveyTemplate("");
                        setIsEdit(false);
                        toggle();
                      }}>
                      <i className=" ri-star-line me-1 align-bottom fs-14"></i>Tambah
                    </button>
                  </div>
                </div>
              </CardHeader>
              <CardBody className="pt-0">
                <div>
                  <Nav
                    className="nav-tabs nav-tabs-custom nav-success"
                    role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames(
                          { active: activeTab === "1" },
                          "fw-semibold"
                        )}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"><i className=" ri-star-line me-1 align-bottom fs-14"></i>  All Template
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames(
                          { active: activeTab === "2" },
                          "fw-semibold"
                        )}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"><i className="ri-information-line me-1 align-bottom fs-14"></i>  DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames(
                          { active: activeTab === "3" },
                          "fw-semibold"
                        )}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"><i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i>  ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames(
                          { active: activeTab === "4" },
                          "fw-semibold"
                        )}
                        onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#"><i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i>  INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={1}>
                            <div className="me-2 mb-2 col-12">
                              <select
                                className="form-select"
                                value={pageSize}
                                onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={7}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Search...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col className="col-xxl-3">
                            <div>
                              <button
                                type="button"
                                className="btn btn-light w-100"
                                onClick={() => {
                                  handleFilter();
                                }}>
                                <i className="ri-search-line me-1 align-bottom fs-14"></i>          Search
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table
                      hover
                      {...getTableProps()}
                      className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr
                            className={""}
                            key={index}
                            {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column, index) => (
                              <th
                                key={index}
                                className={"" + generateFilterable(column)}
                                {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          color="light"
                          onClick={previousPage}
                          disabled={!canPreviousPage}>{"<"}</Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Page
                      <strong>
                        {pageIndex + 1} of {pageOptions.length}</strong>
                    </Col>
                    <Col className="col-md-auto">
                      <Input
                        type="number"
                        min={1}
                        style={{ width: 70 }}
                        max={pageOptions.length}
                        defaultValue={pageIndex + 1}
                        onChange={onChangeInInput}
                      />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          color="light"
                          onClick={nextPage}
                          disabled={!canNextPage}>{">"}</Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Edit Template" : "Add Template"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}>
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-12">

                          <div className="mb-3">
                            <Label
                              htmlFor="client-field"
                              className="form-label">
                              Grup Usaha&nbsp;
                              {clientLoading ? (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              ) : (
                                ""
                              )}
                            </Label>
                            <Select
                              name="client"
                              value={validation.values.client}
                              placeholder="Pilih Grup Usaha"
                              onChange={(e) => {
                                setCompanyList([]);
                                validation.setFieldValue("client", e);
                                handleGetCompany(e.value);
                              }}
                              options={clientList}></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="company" className="form-label">
                              Company        {companyLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="company"
                              placeholder="Enter Company"
                              value={validation.values.company}
                              isDisabled={userType === "admin" || userType === "client" || userType === "company" ? false : true}
                              onChange={(e) => {
                                validation.setFieldValue("company", e);
                              }}
                              onInputChange={(e) => {
                                handleCompany(e);
                              }}
                              options={companyList}></Select>
                            {validation.touched.company &&
                              validation.errors.company ? (
                              <small className="text-danger" type="invalid">
                                {validation.errors.company}
                              </small>
                            ) : null}
                          </div>

                          <div className="mb-3">
                            <Label
                              htmlFor="percentage-field"
                              className="form-label">
                              % Value      </Label>
                            <Input
                              name="percentage"
                              id="percentage-field"
                              className="form-control"
                              placeholder="Enter % Value"
                              type="number"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.percentage}
                              invalid={
                                validation.touched.percentage &&
                                  validation.errors.percentage
                                  ? true
                                  : false
                              } />
                            {validation.touched.percentage &&
                              validation.errors.percentage ? (
                              <FormFeedback type="invalid">
                                {validation.errors.percentage}
                              </FormFeedback>
                            ) : null}
                          </div>

                          <div className="mb-3">
                            <Label
                              htmlFor="description-field"
                              className="form-label">
                              Description
                            </Label>
                            <Input
                              name="description"
                              id="description-field"
                              rows="4"
                              className="form-control"
                              placeholder="Isi Keterangan"
                              type="textarea"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.description} />
                          </div>

                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}>
                          Close
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">
                              {!!isEdit ? "Update" : "Add Template"}
                            </span>
                            {loading && (
                              <Spinner
                                size="sm"
                                className="flex-shrink-0"
                                role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <Modal
                  id="showModalDetail"
                  isOpen={modalDetail}
                  centered
                  size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggleDetail}>
                    {!!isEditDetail
                      ? "Edit Template Detail"
                      : "Add Template Detail"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationDetail.handleSubmit();
                      return false;
                    }}>
                    <ModalBody>
                      <div className="row">
                        <div className="mb-3 col-lg-12">
                          <Label
                            htmlFor="description-field"
                            className="form-label">
                            Description
                          </Label>
                          <Input
                            name="description"
                            id="description-field"
                            rows="4"
                            className="form-control"
                            placeholder="Isi Keterangan"
                            type="textarea"
                            onChange={validationDetail.handleChange}
                            onBlur={validationDetail.handleBlur}
                            value={validationDetail.values.description} />
                        </div>
                        <div className="mb-3 col-lg-6">
                          <Label
                            htmlFor="score-field"
                            className="form-label">
                            Score
                          </Label>
                          <Input
                            name="score"
                            id="score-field"
                            className="form-control"
                            placeholder="Enter Score"
                            type="number"
                            onChange={validationDetail.handleChange}
                            onBlur={validationDetail.handleBlur}
                            value={validationDetail.values.score}
                            invalid={
                              validationDetail.touched.score &&
                                validationDetail.errors.score
                                ? true
                                : false
                            } />
                          {validationDetail.touched.score &&
                            validationDetail.errors.score ? (
                            <FormFeedback type="invalid">
                              {validationDetail.errors.score}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModalDetail(false);
                          }}>
                          Close
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">
                              {!!isEditDetail
                                ? "Update"
                                : "Add Template Detail"}
                            </span>
                            {loading && (
                              <Spinner
                                size="sm"
                                className="flex-shrink-0"
                                role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>

              </CardBody>
            </Card>
          </Col>
          <Col xxl={12}>
            <Card>
              <div className="card-body d-flex align-items-center">
                <h5 className="text-uppercase mb-2 flex-grow-1">
                  {info.name && info.kpipa_position
                    ? info.name + " - " + info.kpipa_position.name
                    : " - "}
                </h5>
                <div className="flex-shrink-0">
                  <button
                    type="button"
                    className={
                      userType === "admin"
                        ? "btn btn-success add-btn"
                        : userRole &&
                          userRole
                            .split(",")
                            .indexOf("createSurveyTemplateDetail") !== -1
                          ? "btn btn-success add-btn"
                          : "btn btn-success add-btn"
                    }
                    id="create-btn"
                    onClick={(e) => {
                      setSurveyTemplate(info);
                      dispatch(resetSurveyScoreState());
                      dispatch(
                        getSurveyScore({
                          companyId: info.svt_company.id,
                        })
                      );
                      setIsEditDetail(false);
                      toggleDetail();
                      e.preventDefault();
                    }}>
                    <i className="ri-list-check label-icon align-middle fs-13 me-1"></i>
                    Add Detail
                  </button>
                  <button
                    className={
                      userType === "admin"
                        ? "btn btn-soft-danger"
                        : userRole &&
                          userRole
                            .split(",")
                            .indexOf("deleteSurveyTemplateDetail") !== -1
                          ? "btn btn-soft-danger"
                          : "btn btn-soft-danger d-none"
                    }
                    onClick={() => setDeleteModalMulti(true)}>
                    <i className="ri-delete-bin-5-line me-1 align-bottom fs-13"></i>
                  </button>
                </div>
              </div>
              <div className="card-body">
                <Row>
                  <CardBody className="border border-top-0 border-end-0 border-start-0">
                    <form>
                      <Row>
                        <Col sm={2}>
                          <div className="me-2 mb-2">
                            <select className="form-select" value={pageSizeSecond} onChange={onChangeInSelectSecond}>
                              {[10, 50, 100, 250, 500].map((pageSizeSecond) => (
                                <option key={pageSizeSecond} value={pageSizeSecond}>
                                  {pageSizeSecond}
                                </option>
                              ))}
                            </select>
                          </div>
                        </Col>
                        <Col sm={4}>
                          <div className="search-box me-2 mb-2 d-inline-block col-12">
                            <input
                              onChange={(e) => {
                                setSearchValueSecond(e.target.value);
                                onChangeSecond(e.target.value);
                              }}
                              id="search-bar-0"
                              type="text"
                              className="form-control search"
                              placeholder={`Search...`}
                              value={searchValueSecond ?? ""} />
                            <i className="bx bx-search-alt search-icon"></i>
                          </div>
                        </Col>
                      </Row>
                    </form>
                  </CardBody>
                </Row>
                <div className="table-responsive table-card mb-1">
                  <Table hover {...getTablePropsSecond()} className="align-middle table-nowrap">
                    <thead className="table-light">
                      {headerGroupsSecond.map((headerGroup, index) => (
                        <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                          {headerGroup.headers.map((column, index) => (
                            <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                              {column.render("Header")}
                              {generateSortingIndicator(column)}
                              {/* <Filter column={column} /> */}
                            </th>
                          ))}
                        </tr>
                      ))}
                    </thead>

                    <tbody {...getTableBodyPropsSecond()}>
                      {pageSecond.map((row) => {
                        prepareRowSecond(row);
                        return (
                          <Fragment key={row.getRowProps().key}>
                            <tr>
                              {row.cells.map((cell, index) => {
                                return (
                                  <td {...cell.getCellProps()} key={index}>
                                    {cell.render("Cell")}
                                  </td>
                                );
                              })}
                            </tr>
                          </Fragment>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
                <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                  <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                  <Col className="col-md-auto">
                    <div className="d-flex gap-1">
                      <Button color="light" onClick={previousPageSecond} disabled={!canPreviousPageSecond}>{"<"}</Button>
                    </div>
                  </Col>
                  <Col className="col-md-auto d-none d-md-block">
                    Halaman {pageIndex + 1} dari {pageOptions.length}
                  </Col>
                  <Col className="col-md-auto">
                    <Input type="number" min={1} style={{ width: 70 }} max={pageOptionsSecond.length} defaultValue={pageIndexSecond + 1} onChange={onChangeInInputSecond} />
                  </Col>
                  <Col className="col-md-auto">
                    <div className="d-flex gap-1">
                      <Button className="btn btn-light" onClick={nextPageSecond} disabled={!canNextPageSecond}>{">"}</Button>
                    </div>
                  </Col>
                </Row>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SurveyTemplate;
